// src/contents/socials.js
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import practoIcon from "../Images/practo-app-icon.png";

const socials = [
  {
    id: "facebook",
    icon: FaFacebookF,
    link: "https://www.facebook.com/hublidentalclinics?mibextid=wwXIfr&rdid=BhTntPx8sMWTDzXb&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1CudYPep6v%2F%3Fmibextid%3DwwXIfr#",
  },
  {
    id: "instagram",
    icon: FaInstagram,
    link: "https://www.instagram.com/dhotraddental",
  },
  {
    id: "linkedin",
    icon: FaLinkedinIn,
    link: "https://www.linkedin.com/in/dhotrad-s-sunny-dental-clinics-639b701b2/?originalSubdomain=in",
  },
  {
    id: "practo",
    image: practoIcon,
    link: "https://www.practo.com/hubli/clinic/dhotrad-s-sunny-dental-clinic-hubli-city-1",
  },
];

export default socials;
